import enhance from './enhancer';
import { Influencer } from './Influencer';

export default enhance(Influencer);
